var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStern02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stern-02__Icn/40px/Stern-02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stern-02__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stern-02__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,6 L24.1144968,14.336881 L33.3147912,15.6737621 L26.6573956,22.163119 L28.2289935,31.3262379 L20,27 L11.7710065,31.3262379 L13.3426044,22.163119 L6.68520877,15.6737621 L15.8855032,14.336881 L20,6 Z M22.7863657,16.1648966 L20,10.519 L17.2136343,16.1648966 L10.983,17.07 L15.4915655,21.4648792 L14.427,27.669 L20,24.7404485 L25.572,27.669 L24.5084345,21.4648792 L29.016,17.07 L22.7863657,16.1648966 Z",
    id: ".._.._src_svg_Icn_40px_Stern-02__Star-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStern02);
export default __webpack_public_path__ + "static/media/Stern-02.7bc79c86855522be9d130438d2ea1525.svg";
export { ForwardRef as ReactComponent };